import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './mentee-topic.reducer';

export const MenteeTopicDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const menteeTopicEntity = useAppSelector(state => state.menteeTopic.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="menteeTopicDetailsHeading">
          <Translate contentKey="fivePlusApp.menteeTopic.detail.title">MenteeTopic</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{menteeTopicEntity.id}</dd>
          <dt>
            <Translate contentKey="fivePlusApp.menteeTopic.user">User</Translate>
          </dt>
          <dd>{menteeTopicEntity.user ? menteeTopicEntity.user.id : ''}</dd>
          <dt>
            <Translate contentKey="fivePlusApp.menteeTopic.topic">Topic</Translate>
          </dt>
          <dd>{menteeTopicEntity.topic ? menteeTopicEntity.topic.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/mentee-topic" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/mentee-topic/${menteeTopicEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MenteeTopicDetail;
